import BossModel from "@/models/BossModel";
import WebsitePage from '@/models/WebsitePage/WebsitePage'
import Container from "@/models/WebsitePage/Version/Container/Container";
import PublicImage from '@/models/PublicImage/PublicImage'

export default class Version extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-page/version';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePageVersions';

    static fields() {
        return {
            id: this.number(null).nullable(),
            header_title: this.attr(null),
            header_subtitle: this.attr(null),
            excerpt: this.attr(null),
            header_public_image_id: this.number(null).nullable(),
            website_page_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            is_product_search: this.number(null).nullable(),
            page: this.belongsTo(WebsitePage, 'website_page_id'),
            containers: this.hasMany(Container, 'website_page_version_id'),
            headerImage: this.belongsTo(PublicImage, 'header_public_image_id'),
        }
    }

    /**
     *
     * @param websitePageId
     * @returns {*}
     */
    static fetchByWebsitePageId(websitePageId) {
        return this.api()
            .limit(0)
            .where('website_page_id', websitePageId)
            .get(true);
    }

    /**
     *
     * @param id
     * @returns {*}
     */
    static fetchContent(id) {
        return this.api()
            .with([
                'containers.elements.row.columns.elements.row.columns.elements.widget.widgetable',
                'containers.elements.row.columns.elements.widget.widgetable',
                'containers.leftPublicImage',
                'containers.rightPublicImage',
                'headerImage',
            ])
            .find(id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Duplicate() {
        return this.constructor.api()
            .action(this.id + '/duplicate')
            .create(this);
    }

    /**
     *
     * @returns {boolean}
     * @constructor
     */
    IsPublished() {
        return this.id == this.WebsitePage().website_page_version_id;
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    pasteSelected(containersIds) {
        return this.constructor.api().action(this.id + '/paste').create({ids: containersIds}, false).then(result => {
            return Version.fetchContent(result.id);
        });
    }

    /**
     *
     * @param draft
     * @param containers
     */
    static updateChildRanks(draft, containers) {
        for (let key in containers) {
            if (Object.prototype.hasOwnProperty.call(containers, key) && containers[key].id !== undefined) {
                containers[key].website_page_draft_id = draft.id;
                containers[key].rank = key;
                containers[key].api().update();
            }
        }
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Publish() {
        return this.constructor.api().action(this.id + '/publish').update(this).then(version => {
            let websitePage = version.WebsitePage();
            websitePage.website_page_version_id = version.id;
            return version;
        });
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    WebsitePage() {
        return this.getRelated('page');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    HeaderImage() {
        return this.getRelated('headerImage');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Containers() {
        return this.getRelated('containers');
    }
}
